export default __webpack_public_path__ + "static/media/logo_bogota.ad8eeea7.svg";